import React from "react";

interface Props {
  children: React.ReactNode;
}

const StaticPage: React.FC<Props> = ({ children }) => {
  return <div className="App">{children}</div>;
};

export default StaticPage;
